// extracted by mini-css-extract-plugin
module.exports = {"collapse":"style_collapse__yvudS","open":"style_open__202Oq"};